import * as React from "react";

const OtpInput: React.FC<{
  code: string;
  setCode: React.Dispatch<React.SetStateAction<string>>;
}> = ({ code, setCode }) => {
  const CODE_LENGTH = new Array(6).fill(0);
  const values = code.split("");
  const input = React.createRef<HTMLInputElement>();
  const [isFocused, setIsFocused] = React.useState(false);
  const selectedIndex =
    values.length < CODE_LENGTH.length ? values.length : CODE_LENGTH.length - 1;

  const handleClick = () => {
    input.current?.focus();
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    if (isFocused) {
      input.current?.blur();
    }
    setIsFocused(false);
  };

  const handleChange = (e: any) => {
    const val = e.target.value;

    if (code.length >= CODE_LENGTH.length) {
      return null;
    }

    const combinedValue = (code + val).slice(0, CODE_LENGTH.length);
    setCode(combinedValue);
    return combinedValue;
  };

  const handleKeyUp = (e: any) => {
    if (e.key === "Backspace") {
      const val = code.slice(0, code.length - 1);
      setCode(val);
      return val;
    }
  };

  const hideInput = !(values.length < CODE_LENGTH.length);

  return (
    <div className="wrap justify-content-center" onClick={handleClick}>
      {CODE_LENGTH.map((v, index) => {
        const selected = values.length === index;
        const filled =
          values.length === CODE_LENGTH.length &&
          index === CODE_LENGTH.length - 1;
        return (
          <div key={index} className="display">
            {values[index]}
            {(selected || filled) && isFocused && <div className="shadows" />}
          </div>
        );
      })}
      <input
        value=""
        inputMode="numeric"
        ref={input}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        onKeyUp={handleKeyUp}
        className="inputOTP"
        style={{
          width: "32px",
          top: "0px",
          bottom: "0px",
          left: `${selectedIndex * 32}px`,
          opacity: hideInput ? 0 : 1,
        }}
      />
    </div>
  );
};

export default OtpInput;
